// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;

import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101'),
	() => import('./nodes/102'),
	() => import('./nodes/103'),
	() => import('./nodes/104'),
	() => import('./nodes/105'),
	() => import('./nodes/106'),
	() => import('./nodes/107'),
	() => import('./nodes/108'),
	() => import('./nodes/109'),
	() => import('./nodes/110'),
	() => import('./nodes/111'),
	() => import('./nodes/112'),
	() => import('./nodes/113'),
	() => import('./nodes/114'),
	() => import('./nodes/115'),
	() => import('./nodes/116'),
	() => import('./nodes/117'),
	() => import('./nodes/118'),
	() => import('./nodes/119'),
	() => import('./nodes/120'),
	() => import('./nodes/121'),
	() => import('./nodes/122'),
	() => import('./nodes/123'),
	() => import('./nodes/124'),
	() => import('./nodes/125'),
	() => import('./nodes/126'),
	() => import('./nodes/127'),
	() => import('./nodes/128'),
	() => import('./nodes/129'),
	() => import('./nodes/130'),
	() => import('./nodes/131'),
	() => import('./nodes/132'),
	() => import('./nodes/133'),
	() => import('./nodes/134'),
	() => import('./nodes/135'),
	() => import('./nodes/136'),
	() => import('./nodes/137'),
	() => import('./nodes/138'),
	() => import('./nodes/139'),
	() => import('./nodes/140'),
	() => import('./nodes/141'),
	() => import('./nodes/142'),
	() => import('./nodes/143'),
	() => import('./nodes/144'),
	() => import('./nodes/145'),
	() => import('./nodes/146'),
	() => import('./nodes/147'),
	() => import('./nodes/148'),
	() => import('./nodes/149'),
	() => import('./nodes/150'),
	() => import('./nodes/151'),
	() => import('./nodes/152'),
	() => import('./nodes/153'),
	() => import('./nodes/154'),
	() => import('./nodes/155'),
	() => import('./nodes/156'),
	() => import('./nodes/157'),
	() => import('./nodes/158'),
	() => import('./nodes/159'),
	() => import('./nodes/160'),
	() => import('./nodes/161'),
	() => import('./nodes/162'),
	() => import('./nodes/163'),
	() => import('./nodes/164'),
	() => import('./nodes/165'),
	() => import('./nodes/166'),
	() => import('./nodes/167'),
	() => import('./nodes/168'),
	() => import('./nodes/169'),
	() => import('./nodes/170'),
	() => import('./nodes/171'),
	() => import('./nodes/172'),
	() => import('./nodes/173'),
	() => import('./nodes/174'),
	() => import('./nodes/175'),
	() => import('./nodes/176'),
	() => import('./nodes/177'),
	() => import('./nodes/178'),
	() => import('./nodes/179'),
	() => import('./nodes/180'),
	() => import('./nodes/181'),
	() => import('./nodes/182'),
	() => import('./nodes/183'),
	() => import('./nodes/184'),
	() => import('./nodes/185'),
	() => import('./nodes/186'),
	() => import('./nodes/187'),
	() => import('./nodes/188'),
	() => import('./nodes/189'),
	() => import('./nodes/190'),
	() => import('./nodes/191'),
	() => import('./nodes/192'),
	() => import('./nodes/193'),
	() => import('./nodes/194'),
	() => import('./nodes/195'),
	() => import('./nodes/196'),
	() => import('./nodes/197'),
	() => import('./nodes/198'),
	() => import('./nodes/199'),
	() => import('./nodes/200'),
	() => import('./nodes/201'),
	() => import('./nodes/202'),
	() => import('./nodes/203'),
	() => import('./nodes/204'),
	() => import('./nodes/205'),
	() => import('./nodes/206'),
	() => import('./nodes/207'),
	() => import('./nodes/208'),
	() => import('./nodes/209'),
	() => import('./nodes/210'),
	() => import('./nodes/211'),
	() => import('./nodes/212'),
	() => import('./nodes/213'),
	() => import('./nodes/214'),
	() => import('./nodes/215'),
	() => import('./nodes/216'),
	() => import('./nodes/217'),
	() => import('./nodes/218'),
	() => import('./nodes/219'),
	() => import('./nodes/220'),
	() => import('./nodes/221'),
	() => import('./nodes/222'),
	() => import('./nodes/223'),
	() => import('./nodes/224'),
	() => import('./nodes/225'),
	() => import('./nodes/226'),
	() => import('./nodes/227'),
	() => import('./nodes/228'),
	() => import('./nodes/229'),
	() => import('./nodes/230'),
	() => import('./nodes/231'),
	() => import('./nodes/232'),
	() => import('./nodes/233'),
	() => import('./nodes/234'),
	() => import('./nodes/235'),
	() => import('./nodes/236'),
	() => import('./nodes/237'),
	() => import('./nodes/238'),
	() => import('./nodes/239'),
	() => import('./nodes/240'),
	() => import('./nodes/241'),
	() => import('./nodes/242'),
	() => import('./nodes/243'),
	() => import('./nodes/244'),
	() => import('./nodes/245'),
	() => import('./nodes/246'),
	() => import('./nodes/247'),
	() => import('./nodes/248'),
	() => import('./nodes/249'),
	() => import('./nodes/250'),
	() => import('./nodes/251'),
	() => import('./nodes/252'),
	() => import('./nodes/253'),
	() => import('./nodes/254'),
	() => import('./nodes/255'),
	() => import('./nodes/256'),
	() => import('./nodes/257'),
	() => import('./nodes/258'),
	() => import('./nodes/259'),
	() => import('./nodes/260'),
	() => import('./nodes/261'),
	() => import('./nodes/262'),
	() => import('./nodes/263'),
	() => import('./nodes/264'),
	() => import('./nodes/265'),
	() => import('./nodes/266'),
	() => import('./nodes/267'),
	() => import('./nodes/268'),
	() => import('./nodes/269'),
	() => import('./nodes/270'),
	() => import('./nodes/271'),
	() => import('./nodes/272'),
	() => import('./nodes/273'),
	() => import('./nodes/274'),
	() => import('./nodes/275'),
	() => import('./nodes/276'),
	() => import('./nodes/277'),
	() => import('./nodes/278'),
	() => import('./nodes/279'),
	() => import('./nodes/280'),
	() => import('./nodes/281'),
	() => import('./nodes/282'),
	() => import('./nodes/283'),
	() => import('./nodes/284'),
	() => import('./nodes/285'),
	() => import('./nodes/286')
];

export const server_loads = [0,29,5,22,26,27,28,9,36,3,16,4];

export const dictionary = {
		"/(marketing)": [~209,[29]],
		"/(marketing)/academics": [226,[29]],
		"/(auth)/(signin)/account-migration/verify/[token]": [38,[2]],
		"/(auth)/(signin)/account-pending": [39,[2]],
		"/(marketing)/(redirects)/(utm)/andreas": [210,[30]],
		"/(dash)/apps/[workspace]/[environment]": [53,[5],[6]],
		"/(dash)/apps/[workspace]/[environment]/deployed/[name]": [55,[5],[6]],
		"/(dash)/apps/[workspace]/[environment]/v2": [56,[5],[6]],
		"/(dash)/apps/[workspace]/[environment]/[appId]": [54,[5],[6]],
		"/(marketing)/articles": [227,[29]],
		"/(auth)/(signin)/authorize": [40,[2]],
		"/(marketing)/(redirects)/(utm)/bigboxswe": [211,[30]],
		"/(marketing)/blog": [~228,[29,31]],
		"/(marketing)/blog/[slug]": [~229,[29,31]],
		"/(marketing)/(redirects)/brand": [217,[30]],
		"/(microsites)/c-function": [259],
		"/(marketing)/(redirects)/careers": [218,[30]],
		"/(marketing)/changelog": [~230,[29]],
		"/(marketing)/changelog/[slug]": [~231,[29]],
		"/(dash)/clusters/[workspace]/[environment]": [57,[5],[6]],
		"/(marketing)/(redirects)/(utm)/cometeer": [212,[30]],
		"/(marketing)/company": [~232,[29]],
		"/(dash)/containers/[workspace]/[environment]": [58,[5],[6]],
		"/(dash)/containers/[workspace]/[environment]/[tab=containersTab]": [59,[5],[6]],
		"/(marketing)/(redirects)/credits": [219,[30]],
		"/(marketing)/customers": [~233,[29]],
		"/(marketing)/(redirects)/(utm)/dancleary": [213,[30]],
		"/(dash)/(redirects)/dashboard": [50,[7]],
		"/(docs)/docs": [195,[19],[20]],
		"/(docs)/docs/cli/latest/[...id]": [~197,[19,21,22],[20]],
		"/(docs)/docs/devin": [198,[19],[20]],
		"/(docs)/docs/examples": [199,[19,23],[20]],
		"/(docs)/docs/examples/[...id]": [200,[19,23],[20]],
		"/(docs)/docs/guide/[...id]": [201,[19,24],[20]],
		"/(docs)/docs/sdk/go/latest/[...id]": [~202,[19,25,26],[20]],
		"/(docs)/docs/sdk/go/releases": [~203,[19,25],[20]],
		"/(docs)/docs/sdk/js/latest/[...id]": [~204,[19,25,27],[20]],
		"/(docs)/docs/sdk/js/releases": [~205,[19,25],[20]],
		"/(docs)/docs/sdk/py/latest/[...id]": [~206,[19,25,28],[20]],
		"/(docs)/docs/sdk/py/releases": [~207,[19,25],[20]],
		"/(docs)/docs/[...fallback]": [196,[19],[20]],
		"/(dash)/endpoints/[workspace]/[environment]": [60,[5],[6]],
		"/(dash)/endpoints/[workspace]/[environment]/create": [62,[5],[6]],
		"/(dash)/endpoints/[workspace]/[environment]/[endpointId]": [61,[5],[6]],
		"/(dash)/evaluations/[workspace]/[environment]": [63,[5,8],[6]],
		"/(dash)/evaluations/[workspace]/[environment]/create": [65,[5,8],[6]],
		"/(dash)/evaluations/[workspace]/[environment]/[jobId]": [64,[5,8],[6]],
		"/(marketing)/(redirects)/events": [220,[30]],
		"/(docs)/examples": [208],
		"/(microsites)/glm-5-endpoint": [~260],
		"/(marketing)/(redirects)/glossary": [221,[30]],
		"/(marketing)/(redirects)/(utm)/gopher": [214,[30]],
		"/(microsites)/gpu-glossary": [261,[33],[34]],
		"/(microsites)/gpu-glossary/[...id]": [262,[33],[34]],
		"/(dash)/(redirects)/home": [51,[7]],
		"/(dash)/id/[id]": [66,[5],[6]],
		"/(dash)/images/[workspace]/[environment]": [67,[5],[6]],
		"/(dash)/internal": [68,[9]],
		"/(dash)/internal/access-requests": [69,[9]],
		"/(dash)/internal/access-requests/audit": [70,[9]],
		"/(dash)/internal/accounts": [71,[9]],
		"/(dash)/internal/accounts/[...rest]": [72,[9]],
		"/(dash)/internal/batch": [73,[9]],
		"/(dash)/internal/billing-groups": [74,[9]],
		"/(dash)/internal/billing-groups/[groupId]": [75,[9]],
		"/(dash)/internal/bizops-audit-logs": [76,[9]],
		"/(dash)/internal/capacity-probes": [77,[9]],
		"/(dash)/internal/clusters": [78,[9]],
		"/(dash)/internal/credit-codes": [79,[9]],
		"/(dash)/internal/cube-memorial": [80,[9]],
		"/(dash)/internal/customer-onboarding": [81,[9]],
		"/(dash)/internal/design": [82,[9,10]],
		"/(dash)/internal/design/colors": [83,[9,10]],
		"/(dash)/internal/design/colors/dataviz": [84,[9,10]],
		"/(dash)/internal/design/components": [85,[9,10]],
		"/(dash)/internal/design/components/button": [86,[9,10]],
		"/(dash)/internal/design/components/checkbox": [87,[9,10]],
		"/(dash)/internal/design/components/dropdown": [88,[9,10]],
		"/(dash)/internal/design/graphics": [89,[9,10]],
		"/(dash)/internal/design/typography": [90,[9,10]],
		"/(dash)/internal/flash": [91,[9]],
		"/(dash)/internal/flash/[hostname]": [92,[9]],
		"/(dash)/internal/fleet-bench": [93,[9]],
		"/(dash)/internal/fraud": [94,[9]],
		"/(dash)/internal/gpu-capacity-management": [95,[9]],
		"/(dash)/internal/gpu-health": [96,[9]],
		"/(dash)/internal/gpus": [97,[9]],
		"/(dash)/internal/incident-management": [98,[9]],
		"/(dash)/internal/leased-notifiers": [99,[9]],
		"/(dash)/internal/logs": [100,[9]],
		"/(dash)/internal/lookup": [101,[9,11]],
		"/(dash)/internal/lookup/[id]": [102,[9,11]],
		"/(dash)/internal/machine-manager": [103,[9]],
		"/(dash)/internal/margins": [104,[9]],
		"/(dash)/internal/oauth-clients": [105,[9]],
		"/(dash)/internal/plans": [106,[9]],
		"/(dash)/internal/plans/change-workspace-plan": [108,[9]],
		"/(dash)/internal/plans/new": [109,[9]],
		"/(dash)/internal/plans/[plan_id]": [107,[9]],
		"/(dash)/internal/queues": [110,[9]],
		"/(dash)/internal/reservations": [111,[9]],
		"/(dash)/internal/resources": [112,[9]],
		"/(dash)/internal/resources/fullscreen": [113],
		"/(dash)/internal/sandbox-capacity-supply": [114,[9]],
		"/(dash)/internal/solver": [115,[9]],
		"/(dash)/internal/training-capacity": [116,[9]],
		"/(dash)/internal/users": [117,[9,12]],
		"/(dash)/internal/users/[userId]": [118,[9,12,13]],
		"/(dash)/internal/users/[userId]/administration": [119,[9,12,13]],
		"/(dash)/internal/users/[userId]/identity-providers": [120,[9,12,13]],
		"/(dash)/internal/users/[userId]/memberships": [121,[9,12,13]],
		"/(dash)/internal/worker-timeline": [122,[9]],
		"/(dash)/internal/workers": [123,[9]],
		"/(dash)/internal/workspaces": [124,[9,14]],
		"/(dash)/internal/workspaces/[workspace]": [125,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/access": [126,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/billing": [127,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/credits": [128,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/egress": [129,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/environments": [130,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/invites": [131,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/invoices": [132,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/limits-and-overrides": [133,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/members": [134,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/plan-history": [136,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/plan": [135,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/reservations": [137,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/resources": [138,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/stripe-controls": [139,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/usage": [140,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/workers": [141,[9,14,15]],
		"/(marketing)/(redirects)/jobs": [222,[30]],
		"/(marketing)/legal/dpa": [234,[29]],
		"/(marketing)/legal/event": [235,[29]],
		"/(marketing)/legal/privacy-policy": [236,[29]],
		"/(marketing)/legal/terms-effective-date-march-2024": [238,[29]],
		"/(marketing)/legal/terms-effective-date-october-2025": [239,[29]],
		"/(marketing)/legal/terms": [237,[29]],
		"/(marketing)/library": [~240,[29]],
		"/(marketing)/library/[providerSlug]/[modelSlug]": [~241,[29]],
		"/(microsites)/llm-almanac": [263,[35]],
		"/(microsites)/llm-almanac/advisor": [264,[35]],
		"/(microsites)/llm-almanac/block-quants/[[format]]": [265,[35]],
		"/(microsites)/llm-almanac/how-to-benchmark": [266,[35]],
		"/(microsites)/llm-almanac/quant-formats/[[encoded]]": [267,[35]],
		"/(microsites)/llm-almanac/spec-dec-roofline": [268,[35]],
		"/(microsites)/llm-almanac/summary": [269,[35]],
		"/(microsites)/llm-almanac/token-timing-simulator": [270,[35]],
		"/(microsites)/llm-almanac/workloads": [271,[35]],
		"/(auth)/(signin)/login": [41,[2]],
		"/(auth)/(signin)/login/sso": [42,[2]],
		"/(dash)/logs/[workspace]/[environment]": [142,[5],[6]],
		"/(dash)/logs/[workspace]/[environment]/[appId]": [143,[5],[6]],
		"/(marketing)/(redirects)/lp/academics": [223,[30]],
		"/(marketing)/(redirects)/lp/startups": [224,[30]],
		"/notebooks": [281],
		"/(dash)/notebooks/new/[...external_url]": [145,[5],[6]],
		"/notebooks/[workspace]/_/[id]": [284],
		"/notebooks/[workspace]/[id=likelyNotebookId]": [283],
		"/(dash)/notebooks/[workspace]/[environment]": [144,[5],[6]],
		"/notebooks/[workspace]/[environment]/[notebookId]": [282,[36]],
		"/(auth)/oauth/consent/[oauthRequestId]": [44,[3]],
		"/(marketing)/partners": [242,[29]],
		"/playground": [285,[37]],
		"/playground/[slug]": [286,[37]],
		"/(marketing)/(redirects)/(utm)/pragmatic": [215,[30]],
		"/(marketing)/pricing": [243,[29]],
		"/(marketing)/products/batch": [244,[29]],
		"/(marketing)/products/inference": [~245,[29]],
		"/(marketing)/products/notebooks": [~246,[29]],
		"/(marketing)/products/platform": [~247,[29]],
		"/(marketing)/products/sandboxes": [~248,[29]],
		"/(marketing)/products/training": [~249,[29]],
		"/(microsites)/runtime": [272],
		"/(microsites)/runtime/archive": [273],
		"/(microsites)/runtime/archive/agenda": [274],
		"/(microsites)/runtime/archive/map": [275],
		"/(microsites)/runtime/lab": [276],
		"/(microsites)/runtime/lab/badge": [277],
		"/(microsites)/runtime/lab/badge/card": [278],
		"/(microsites)/runtime/partner": [279],
		"/(microsites)/runtime/speakers": [280],
		"/(dash)/sandboxes/[workspace]/[environment]": [146,[5],[6]],
		"/(dash)/secrets/[workspace]/[environment]": [147,[5],[6]],
		"/(dash)/secrets/[workspace]/[environment]/create": [149,[5],[6]],
		"/(dash)/secrets/[workspace]/[environment]/[name]": [148,[5],[6]],
		"/(dash)/settings": [150,[16]],
		"/(dash)/settings/[[workspace]]/access-controls": [156,[16,17,18]],
		"/(dash)/settings/[[workspace]]/access-controls/environments": [157,[16,17,18]],
		"/(dash)/settings/[[workspace]]/access-grants": [158,[16,17]],
		"/(dash)/settings/[[workspace]]/audit-logs": [159,[16,17]],
		"/(dash)/settings/[[workspace]]/billing": [160,[16,17]],
		"/(dash)/settings/[[workspace]]/custom-domains": [161,[16,17]],
		"/(dash)/settings/[[workspace]]/(redirects)/domains": [151,[16,17]],
		"/(dash)/settings/[[workspace]]/environments": [162,[16,17]],
		"/(dash)/settings/[[workspace]]/image-builder-version": [163,[16,17]],
		"/(dash)/settings/[[workspace]]/(redirects)/image-config": [152,[16,17]],
		"/(dash)/settings/[[workspace]]/limits": [164,[16,17]],
		"/(dash)/settings/[[workspace]]/metrics": [165,[16,17]],
		"/(dash)/settings/notifications": [184,[16]],
		"/(dash)/settings/[[workspace]]/page-an-engineer": [166,[16,17]],
		"/(dash)/settings/[[workspace]]/plans": [167,[16,17]],
		"/(dash)/settings/profile": [185,[16]],
		"/(dash)/settings/[[workspace]]/proxies": [168,[16,17]],
		"/(dash)/settings/[[workspace]]/proxy-auth-tokens": [169,[16,17]],
		"/(dash)/settings/[[workspace]]/(redirects)/proxy": [153,[16,17]],
		"/(dash)/settings/[[workspace]]/(redirects)/slack-integration": [154,[16,17]],
		"/(dash)/settings/[[workspace]]/slack-notifications": [170,[16,17]],
		"/(dash)/settings/[[workspace]]/tokens": [171,[16,17]],
		"/(dash)/settings/[[workspace]]/tokens/api-tokens": [172,[16,17]],
		"/(dash)/settings/[[workspace]]/tokens/member-tokens": [173,[16,17]],
		"/(dash)/settings/[[workspace]]/tokens/service-users": [174,[16,17]],
		"/(dash)/settings/[[workspace]]/usage": [175,[16,17]],
		"/(dash)/settings/[[workspace]]/webhooks": [176,[16,17]],
		"/(dash)/settings/[[workspace]]/workspace-management": [177,[16,17]],
		"/(dash)/settings/[[workspace]]/workspace-management/environments": [178,[16,17]],
		"/(dash)/settings/[[workspace]]/workspace-management/environments/all": [179,[16,17]],
		"/(dash)/settings/[[workspace]]/workspace-management/environments/workspace-defaults": [180,[16,17]],
		"/(dash)/settings/[[workspace]]/workspace-management/groups": [181,[16,17]],
		"/(dash)/settings/[[workspace]]/workspace-management/identity-and-provisioning": [182,[16,17]],
		"/(dash)/settings/[[workspace]]/(redirects)/workspace-management/limits": [155,[16,17]],
		"/(dash)/settings/[[workspace]]/workspace-management/members": [183,[16,17]],
		"/(dash)/settings/workspaces": [186,[16]],
		"/(auth)/(signin)/signup": [43,[2]],
		"/(dash)/slack-link-workspace/[[workspace]]": [187,[5],[6]],
		"/(marketing)/(redirects)/slack": [225,[30]],
		"/(marketing)/solutions/audio": [250,[29]],
		"/(marketing)/solutions/coding-agents": [251,[29]],
		"/(marketing)/solutions/comp-bio": [252,[29]],
		"/(marketing)/solutions/image-and-video": [253,[29]],
		"/(marketing)/solutions/llm": [254,[29]],
		"/(marketing)/startups": [255,[29]],
		"/(dash)/storage/[workspace]/[environment]": [188,[5],[6]],
		"/(dash)/storage/[workspace]/[environment]/dicts": [190,[5],[6]],
		"/(dash)/storage/[workspace]/[environment]/nfs": [191,[5],[6]],
		"/(dash)/storage/[workspace]/[environment]/queues": [192,[5],[6]],
		"/(dash)/storage/[workspace]/[environment]/volumes": [193,[5],[6]],
		"/(dash)/storage/[workspace]/[environment]/volumes/[name]/[...dirName]": [194,[5],[6]],
		"/(dash)/storage/[workspace]/[environment]/[name]/[...dirName]": [189,[5],[6]],
		"/(marketing)/(redirects)/(utm)/t3gg": [216,[30]],
		"/(auth)/token-flow/[tokenFlowId]": [45,[4]],
		"/(marketing)/use-cases": [256,[29]],
		"/(marketing)/use-cases/[usecase]": [257,[29]],
		"/(marketing)/v2/components-test": [258,[32]],
		"/(dash)/(redirects)/[workspace=workspace]/[environment]/apps/[...rest]": [46,[7]],
		"/(dash)/(redirects)/[workspace=workspace]/[environment]/logs/[...rest]": [47,[7]],
		"/(dash)/(redirects)/[workspace=workspace]/[environment]/secrets/[...rest]": [48,[7]],
		"/(dash)/(redirects)/[workspace=workspace]/[environment]/storage/[...rest]": [49,[7]],
		"/(dash)/[fallback=dash]/[...rest]": [52,[5],[6]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);